import React from 'react';
import config from '../config';

/**
 * Composant pour afficher les informations de debug en mode développement
 */
const DebugInfo: React.FC = () => {
  // N'afficher que si le mode debug est activé
  if (!config.app.debug) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 bg-gray-800 text-white p-3 rounded-lg text-xs font-mono opacity-75 z-50">
      <div className="font-bold mb-2">🔧 Debug Info</div>
      <div>Environment: {config.environment}</div>
      <div>API URL: {config.api.url}</div>
      <div>Version: {config.app.version}</div>
      <div>Timeout: {config.api.timeout}ms</div>
    </div>
  );
};

export default DebugInfo;
